import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { lpcoEnvs } from "@/tz/go/egaz/osci/lpco/comn";

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 */
export const BASE = {
    path: `${lpcoEnvs.base}/colt/intf`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/colt/intf/recc`,
    recc_api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/fee`,
    nodes: [
        { path: "/", label: "Collection" },
        { path: "/colt/", label: "Collection Management" },
        { path: "/colt/intf/", label: "Notice Interface Management" },
    ],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 */
export const URLS = {
    osci0406009q: `/osci/colt/intf/osci0406009q`, // 정산 처리 이력 목록 조회
    osci0406010q: `/osci/colt/intf/osci0406010q`, // 정산 처리 이력 상세 조회 팝업
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Get Reconciliation History List !== 정산 처리 이력 목록 조회 ==!
    getReccList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/reccLst?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get Reconciliation History Detail List !== 정산 처리 이력 상세 목록 조회 (전체) ==!
    getReccDtlList: (rqstId: string) => {
        return api.get(`${BASE.api}/${rqstId}/reccDtlLst`);
    },
    rqstRecc: () => {
        return api.post(`${BASE.recc_api}/rqstRecc`);
    },
};

/*
 * @ 그리드 스키마 정의
 * @ SG_ 로 시작 (Schema grid)
 */
// Schema of Reconciliation History List Grid !== 정산 처리 이력 목록 그리드 스키마 ==!
export const SG_RECC_LIST: TGridSchema = {
    id: "grid_reccList",
    options: {
        pagination: "out", // 그리드 데이터 페이징 "out" : 외부 페이징
        index: true, // 그리드 번호
        edit: false, // 그리드 편집 가능 여부
    },
    head: [
        { cells: [{ header: "L_RQST_DTM", binding: "rqstDtm", width: 250 }] },
        { cells: [{ header: "L_SEND_DT", binding: "zmpReccRqstDt", width: 120 }] },
        { cells: [{ header: "L_PRCSS_STAT", binding: "bllReccStatNm", width: 160 }] },
        { cells: [{ header: "L_RCVE_CD", binding: "rspnStatCd", width: 160 }] },
        { cells: [{ header: "L_RMRK", binding: "rspnStatCn", width: "*" }] },
        { cells: [{ header: "L_RCV_DT", binding: "rspnDtm", width: 170 }] },
        { cells: [{ header: "L_CNT", binding: "dtlCnt", width: 100 }] },
        { cells: [{ header: "L_RQST_USER_NM", binding: "frstRegstId", width: 170 }] },
    ],
    body: [
        { cells: [{ binding: "rqstDtm", type: "datetime" }] },
        { cells: [{ binding: "zmpReccRqstDt", type: "date" }] },
        { cells: [{ binding: "bllReccStatNm" }] },
        { cells: [{ binding: "rspnStatCd" }] },
        { cells: [{ binding: "rspnStatCn", align: "left" }] },
        { cells: [{ binding: "rspnDtm", type: "datetime" }] },
        { cells: [{ binding: "dtlCnt", type: "number", thousandSeparator: true, align: "right" }] },
        { cells: [{ binding: "frstRegstId", type: "text" }] },
    ],
};

// Schema of Reconciliation History Detail List Grid !== 정산 처리 이력 상세 목록 그리드 스키마 ==!
export const SG_RECC_DTL_LIST: TGridSchema = {
    id: "grid_reccDtlList",
    options: {
        index: true, // 그리드 번호
        edit: false, // 그리드 편집 가능 여부
        height: "auto",
    },
    head: [
        { cells: [{ header: "L_STAT", binding: "updtYnNm", width: 100 }] },
        { cells: [{ header: "L_BLL_NO", binding: "bllNo", width: 270 }] },
        { cells: [{ header: "L_CTRL_NO", binding: "payCtrlNo", width: 130 }] },
        { cells: [{ header: "L_BLL_AMT", binding: "bllAmt", width: 130 }] },
        { cells: [{ header: "L_PAY_AMT", binding: "payAmt", width: 130 }] },
        { cells: [{ header: "L_CURR_CD", binding: "currCd", width: 80 }] },
        { cells: [{ header: "L_RCPT_NO", binding: "rcptNo", width: 160 }] },
        { cells: [{ header: "L_PAY_DTM", binding: "zmpTrscDtm", width: 170 }] },
        { cells: [{ header: "L_RCPT_BNK", binding: "pspNm", width: 200 }] },
        { cells: [{ header: "L_RCPT_BNK_ACCT", binding: "payAcctNo", width: 140 }] },
        { cells: [{ header: "L_PYER_NM", binding: "pyerNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "updtYnNm" }] },
        { cells: [{ binding: "bllNo" }] },
        { cells: [{ binding: "payCtrlNo" }] },
        { cells: [{ binding: "bllAmt", type: "number", thousandSeparator: true, align: "right" }] },
        { cells: [{ binding: "payAmt", type: "number", thousandSeparator: true, align: "right" }] },
        { cells: [{ binding: "currCd" }] },
        { cells: [{ binding: "rcptNo" }] },
        { cells: [{ binding: "zmpTrscDtm", type: "datetime" }] },
        { cells: [{ binding: "pspNm", align: "left" }] },
        { cells: [{ binding: "payAcctNo" }] },
        { cells: [{ binding: "pyerNm", align: "left" }] },
    ],
};

/*
 * @ Form 스키마 정의
 * @ SF_ 로 시작 (Schema form)
 */
// Schema of Reconciliation History Search Form !== 정산 처리 이력 검색 폼 스키마 ==!
export const SF_RECC_SRCH: TFormSchema = {
    id: "form_reccSrch",
    schema: {
        sendDt: {
            type: "daterange",
            label: "L_SEND_DT",
            start: { name: "strtDt", required: true },
            end: { name: "endDt", required: true },
            required: true,
            rangeButton: 0,
            controlSize: 10,
        },
    },
};
